// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_ruby-dark":"#bf4a42","errorMessage":"error-message_errorMessage__14DZK"};